import React from "react";
import {Container, Row, Col, CardDeck} from 'react-bootstrap';
import {ModalMachines} from "./ModalMachines";
import '../styles/components/machines.css'

const dataCNC = "<p>Trabaja con: Madera, Tecnyl, Aluminio</p> <p><strong><u>- Fresado cil&iacute;ndrico:&nbsp;</u></strong></p> <p>Largo m&aacute;ximo: 914.4mm</p> <p>Di&aacute;metro m&aacute;ximo: 203.2mm</p> <p><strong><u>- Fresado en relieve:</u></strong></p> <p>Volumen de trabajo:</p> <ul> <li>Desktop: 610 x 460 x 140mm</li> <li>PRS Standard: 2670 x 1240 x 200mm</li> </ul> <p>Software de apoyo: Autodesk Inventor + HSM, Fusion 360</p>"	
const data3DPRINTER = "<p>Trabaja con: PLA, PETG, PVA, ABS</p><p>Volumen de trabajo:</p><ul><li>Monomaterial: 215 x 215 x 300mm</li><li>Multimaterial: 197 x 215 x 300mm</li></ul><p>Software de control: Ultimaker Cura</p><p>Formatos soportados: STL, OBJ, DAE, AMF</p>"
const cortadoraLaser = "<p><strong><u>- Grabado</u></strong></p><p>Trabaja con: Madera, Acr&iacute;lico, Vidrio</p><div><ul><li><strong><u>Cil&iacute;ndrico:</u></strong></li></ul></div><p>Largo m&aacute;ximo: 450mm</p><p>Di&aacute;metros interiores: 50-76 mm, 12-46mm</p><p>Di&aacute;metro exterior: 176mm</p><div><ul><li><strong><u>En 2D:</u></strong></li></ul></div><p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&Aacute;rea de trabajo:</p><ol><li>X252: 635 x 458mm</li><li>X500 III: 1300 x 916mm</li></ol><p>Software de dibujo raster: Corel Draw, Adobe Illustrator, Adobe Photoshop</p><p>&nbsp;</p><p><strong><u>- Corte en 2D</u></strong></p><p>Trabaja con: Madera, Acr&iacute;lico</p><p>&Aacute;rea de trabajo:</p><ul><li>X252: 635 x 458mm</li><li>X500 III: 1300 x 916mm</li></ul><p>Software de dibujo vectorial: Corel Draw, Adobe Illustrator, AutoCAD</p'"
const dataTorno = "<p>Trabaja con: Tecnyl, Aluminio, Acero</p><p>Distancia m&aacute;xima: 510mm</p><p>Di&aacute;metro m&aacute;ximo: 210mm</p><p>Recorrido: 100mm</p><p>Velocidad: 125-2000RPM</p>"
const dataVinilo = "<p><strong><u>- Especificaciones&nbsp;</u></strong></p> <p>Model: Vinilo Cameo 4 Plus</p> <p>Es una herramienta que se utiliza para cortar dise&ntilde;os y que es imprescindible para trabajar con vinilo, ya sea textil o de rotulaci&oacute;n.</p>"
const dataCirqoid ="<p><strong><u>- Especificaciones</u></strong></p><p>Tama&ntilde;o m&aacute;ximo de PCB: 100x160mm</p><p>Resoluci&oacute;n mec&aacute;nica: 0.01mm</p><p>Resoluci&oacute;n del Software: 1.25 &micro;m</p><p>Respetibilidad: &lt;0.02mm</p><p>Velocidad de desplazamiento m&aacute;xima, eje X: 1200 mm/min</p><p>Velocidad de desplazamiento m&aacute;xima, eje Y: 1000 mm/min</p><p>Velocidad de desplazamiento m&aacute;xima, eje Z: 1500 mm/min</p><p>Dimensiones: 280x470x380mm</p><p>Peso sin accesorio: 14Kg.</p><p>Software: cirQWizard</p><p>Cabezales</p>"

const first_machines_json = [
	[
		{name: "Router CNC", img: "milling.svg", title: "Router CNC", data: dataCNC, video: "cnc.mp4"},
		{name: "Cortadora láser", img: "laser.svg", title: "Cortadora Láser", data: cortadoraLaser , video: "laser.mp4"},
		{name: "Cortadora de vinilo", img: "vinylcutter.svg", title: "Cortadora de Vinilos", data: dataVinilo, video: "vinylcutter.mp4"},
	],
	[
		{name: "Impresora 3D", img: "3dprinter.svg", title: "Impresora 3D", data: data3DPRINTER, video: "3dprinter.mp4"},
		{name: "Cirqoid", img: "pcb.svg", title: "Cirqoid", data: dataCirqoid, video: "cirqoid.mp4"},
		{name: "Torno", img: "turnstile.svg", title: "Torno", data: dataTorno, video: "turnstile.mp4"},
	],
	[
		{name: "WorkStation", img: "workstation.svg", title: "", data: "", video: ""},
		{name: "Zona para soldar", img: "solderingiron.svg", title: "", data: "", video: ""},
		{name: "Zona para medir circuitos", img: "ammeter.svg", title: "", data: "", video: ""},
	]
]

export const Machines=()=> {  

  return (
	<>	
	<Container fluid style={{backgroundColor: 'var(--gray)'}}>
        <Container className="fablab-container" id="maquinas">
			<Row>
				<Col>
				  <h1 className="fablab-title white">Máquinas</h1>
				</Col>
          	</Row>
			<Row>
				<Col>
				{
					first_machines_json.map((machines, index) =>
					<CardDeck key={index}>
						{
							machines.map(({name, img, title, data, video}) =>
								<ModalMachines key={name} name={name} img={img} title={title} data={data} video={video}/>
							)
						}
					</CardDeck>
					)
				}
				</Col>
			</Row>
		</Container>
	</Container>
	</>
  );
}